import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FileSelectionComponent } from '../file-selection/file-selection.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgClass } from '@angular/common';

@Component({
  selector: 'app-formly-file-selection',
  standalone: true,
  imports: [
    NgClass,
    CommonModule,
    FormlyModule,
    ReactiveFormsModule,
    FileSelectionComponent,
  ],
  templateUrl: './formly-file-selection.component.html',
  styleUrl: './formly-file-selection.component.scss'
})
export class FormlyFileSelectionComponent extends FieldType<FieldTypeConfig> {

}
